import { lazy, Suspense } from 'react';
import type HighchartsReact from 'highcharts-react-official';
import type { PopoverProps, TitleProps } from '../ui';
import { Skeleton } from '../ui';

export type HighchartsReactProps = HighchartsReact.Props & {
  isLoading?: boolean;
  title?: TitleProps;
  popover?: PopoverProps;
};

const SHighcharts = lazy(() => import('./Highcharts.styles'));

const paragraph = {
  rows: 3,
};

export function Highcharts(props: HighchartsReactProps) {
  return (
    <Suspense fallback={<Skeleton active paragraph={paragraph} />}>
      <SHighcharts immutable {...props} />
    </Suspense>
  );
}
